import "reflect-metadata";
import {Container} from "inversify";
import "../version.js";

import * as madnesAdapter from "./adapters/madnesAdapter";

import {defineEngine} from "../framework/src/engine/madnes/bootMadnesEngine";
import {boot} from "../framework/src/boot/boot";
import {defineSystem} from "../framework/src/system/defineSystem";
import {defineGame} from "../framework/src/engine/madnes/bootMadnesEngine";
import {defineUI} from "../framework/src/ui/defineUI";
import {defineRegulation} from "../framework/src/regulations/defineRegulations";
import initSettings from "../framework/src/settings/initSettings";
import {defineJokerWinBanner} from "./JokerWinBanner";


let container = new Container();

export async function run (gameset) {
    defineSystem(gameset, container);
    defineEngine(madnesAdapter, container);
    defineGame(container);
    try {
        await initSettings(container);
    } catch(error) {
        return
    } 
    defineUI(container);
    defineRegulation(container);
    defineJokerWinBanner(container);
    boot(container);
}
